function getFocusableElements(a) {
  return Array.from(
    a.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((a) => {
  a.setAttribute("role", "button"),
    a.setAttribute("aria-expanded", a.parentNode.hasAttribute("open")),
    a.nextElementSibling.getAttribute("id") &&
      a.setAttribute("aria-controls", a.nextElementSibling.id),
    a.addEventListener("click", (a) => {
      a.currentTarget.setAttribute(
        "aria-expanded",
        !a.currentTarget.closest("details").hasAttribute("open")
      );
    }),
    a.closest("header-drawer") ||
      a.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(b, c = b) {
  var a = getFocusableElements(b),
    d = a[0],
    e = a[a.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (a) => {
      (a.target === b || a.target === e || a.target === d) &&
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (a) {
      "TAB" === a.code.toUpperCase() &&
        (a.target !== e || a.shiftKey || (a.preventDefault(), d.focus()),
        (a.target === b || a.target === d) &&
          a.shiftKey &&
          (a.preventDefault(), e.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    c.focus();
}
try {
  document.querySelector(":focus-visible");
} catch (a) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  let a = [
      "ARROWUP",
      "ARROWDOWN",
      "ARROWLEFT",
      "ARROWRIGHT",
      "TAB",
      "ENTER",
      "SPACE",
      "ESCAPE",
      "HOME",
      "END",
      "PAGEUP",
      "PAGEDOWN",
    ],
    b = null,
    c = null;
  window.addEventListener("keydown", (b) => {
    a.includes(b.code.toUpperCase()) && (c = !1);
  }),
    window.addEventListener("mousedown", (a) => {
      c = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        b && b.classList.remove("focused"),
          c || (b = document.activeElement).classList.add("focused");
      },
      !0
    );
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((a) => {
    a.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((a) => {
      a.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("video").forEach((a) => a.pause()),
    document.querySelectorAll("product-model").forEach((a) => {
      a.modelViewerUI && a.modelViewerUI.pause();
    });
}
function removeTrapFocus(a = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    a && a.focus();
}
function onKeyUpEscape(b) {
  if ("ESCAPE" !== b.code.toUpperCase()) return;
  let a = b.target.closest("details[open]");
  if (!a) return;
  let c = a.querySelector("summary");
  a.removeAttribute("open"), c.setAttribute("aria-expanded", !1), c.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.querySelectorAll("button").forEach((a) =>
        a.addEventListener("click", this.onButtonClick.bind(this))
      );
  }
  onButtonClick(a) {
    a.preventDefault();
    let b = this.input.value;
    "plus" === a.target.name ? this.input.stepUp() : this.input.stepDown(),
      b !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
}
function debounce(a, b) {
  let c;
  return (...d) => {
    clearTimeout(c), (c = setTimeout(() => a.apply(this, d), b));
  };
}
function fetchConfig(a = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${a}` },
  };
}
customElements.define("quantity-input", QuantityInput),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (a, b) {
    return function () {
      return a.apply(b, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (b, c) {
    for (var a = 0, e = b.options.length; a < e; a++) {
      var d = b.options[a];
      if (c == d.value || c == d.innerHTML) return (b.selectedIndex = a), a;
    }
  }),
  (Shopify.addListener = function (a, b, c) {
    a.addEventListener
      ? a.addEventListener(b, c, !1)
      : a.attachEvent("on" + b, c);
  }),
  (Shopify.postLink = function (f, c) {
    var g = (c = c || {}).method || "post",
      d = c.parameters || {},
      a = document.createElement("form");
    for (var e in (a.setAttribute("method", g),
    a.setAttribute("action", f),
    d)) {
      var b = document.createElement("input");
      b.setAttribute("type", "hidden"),
        b.setAttribute("name", e),
        b.setAttribute("value", d[e]),
        a.appendChild(b);
    }
    document.body.appendChild(a), a.submit(), document.body.removeChild(a);
  }),
  (Shopify.CountryProvinceSelector = function (b, a, c) {
    (this.countryEl = document.getElementById(b)),
      (this.provinceEl = document.getElementById(a)),
      (this.provinceContainer = document.getElementById(c.hideElement || a)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
      ),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var a = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, a), this.countryHandler();
    },
    initProvince: function () {
      var a = this.provinceEl.getAttribute("data-default");
      a &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, a);
    },
    countryHandler: function (e) {
      var a = this.countryEl.options[this.countryEl.selectedIndex],
        d = a.getAttribute("data-provinces"),
        b = JSON.parse(d);
      if ((this.clearOptions(this.provinceEl), b && 0 == b.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var c = 0; c < b.length; c++) {
          var a = document.createElement("option");
          (a.value = b[c][0]),
            (a.innerHTML = b[c][1]),
            this.provinceEl.appendChild(a);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (a) {
      for (; a.firstChild; ) a.removeChild(a.firstChild);
    },
    setOptions: function (d, a) {
      for (var b = 0; b < a.length; b++) {
        var c = document.createElement("option");
        (c.value = a[b]), (c.innerHTML = a[b]), d.appendChild(c);
      }
      a.length;
    },
  });
class MenuDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      "iPhone" === navigator.platform &&
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        ),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((a) =>
      a.addEventListener("click", this.onSummaryClick.bind(this))
    ),
      this.querySelectorAll("button").forEach((a) =>
        a.addEventListener("click", this.onCloseButtonClick.bind(this))
      );
  }
  onKeyUp(a) {
    if ("ESCAPE" !== a.code.toUpperCase()) return;
    let b = a.target.closest("details[open]");
    b &&
      (b === this.mainDetailsToggle
        ? this.closeMenuDrawer(
            a,
            this.mainDetailsToggle.querySelector("summary")
          )
        : this.closeSubmenu(b));
  }
  onSummaryClick(a) {
    let b = a.currentTarget,
      c = b.parentNode,
      e = c.closest(".has-submenu"),
      d = c.hasAttribute("open"),
      f = window.matchMedia("(prefers-reduced-motion: reduce)");
    function g() {
      trapFocus(b.nextElementSibling, c.querySelector("button")),
        b.nextElementSibling.removeEventListener("transitionend", g);
    }
    c === this.mainDetailsToggle
      ? (d && a.preventDefault(),
        d ? this.closeMenuDrawer(a, b) : this.openMenuDrawer(b))
      : setTimeout(() => {
          c.classList.add("menu-opening"),
            b.setAttribute("aria-expanded", !0),
            e && e.classList.add("submenu-open"),
            !f || f.matches
              ? g()
              : b.nextElementSibling.addEventListener("transitionend", g);
        }, 100);
  }
  openMenuDrawer(a) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      a.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, a),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(a, b = !1) {
    void 0 !== a &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
      this.mainDetailsToggle.querySelectorAll("details").forEach((a) => {
        a.removeAttribute("open"), a.classList.remove("menu-opening");
      }),
      this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((a) => {
        a.classList.remove("submenu-open");
      }),
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      ),
      removeTrapFocus(b),
      this.closeAnimation(this.mainDetailsToggle));
  }
  onFocusOut(a) {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(a) {
    let b = a.currentTarget.closest("details");
    this.closeSubmenu(b);
  }
  closeSubmenu(a) {
    let b = a.closest(".submenu-open");
    b && b.classList.remove("submenu-open"),
      a.classList.remove("menu-opening"),
      a.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(a.querySelector("summary")),
      this.closeAnimation(a);
  }
  closeAnimation(b) {
    let c,
      a = (d) => {
        void 0 === c && (c = d),
          d - c < 400
            ? window.requestAnimationFrame(a)
            : (b.removeAttribute("open"),
              b.closest("details[open]") &&
                trapFocus(
                  b.closest("details[open]"),
                  b.querySelector("summary")
                ));
      };
    window.requestAnimationFrame(a);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  openMenuDrawer(a) {
    (this.header =
      this.header || document.getElementById("shopify-section-header")),
      (this.borderOffset =
        this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      ),
      this.header.classList.add("menu-open"),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      a.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, a),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(a, b) {
    super.closeMenuDrawer(a, b), this.header.classList.remove("menu-open");
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this, !1)
      ),
      this.addEventListener("keyup", (a) => {
        "ESCAPE" === a.code.toUpperCase() && this.hide();
      }),
      this.classList.contains("media-modal")
        ? this.addEventListener("pointerup", (a) => {
            "mouse" !== a.pointerType ||
              a.target.closest("deferred-media, product-model") ||
              this.hide();
          })
        : this.addEventListener("click", (a) => {
            a.target === this && this.hide();
          });
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
  }
  show(b) {
    this.openedBy = b;
    let a = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden"),
      this.setAttribute("open", ""),
      a && a.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove("overflow-hidden"),
      document.body.dispatchEvent(new CustomEvent("modalClosed")),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    let a = this.querySelector("button");
    if (!a) return;
    a.addEventListener("click", () => {
      let b = document.querySelector(this.getAttribute("data-modal"));
      b && b.show(a);
    });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    let a = this.querySelector('[id^="Deferred-Poster-"]');
    if (!a) return;
    a.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(b = !0) {
    if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
      let a = document.createElement("div");
      a.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(!0)
      ),
        this.setAttribute("loaded", !0);
      let c = this.appendChild(a.querySelector("video, model-viewer, iframe"));
      b && c.focus();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector(
        ".slider-counter--current"
      )),
      (this.pageTotalElement = this.querySelector(".slider-counter--total")),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      !this.slider || !this.nextButton)
    )
      return;
    this.initPages();
    let a = new ResizeObserver((a) => this.initPages());
    a.observe(this.slider),
      this.slider.addEventListener("scroll", this.update.bind(this)),
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }
  initPages() {
    (this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (a) => a.clientWidth > 0
    )),
      this.sliderItemsToShow.length < 2 ||
        ((this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetLeft -
          this.sliderItemsToShow[0].offsetLeft),
        (this.slidesPerPage = Math.floor(
          (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
            this.sliderItemOffset
        )),
        (this.totalPages =
          this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.update());
  }
  resetPages() {
    (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      this.initPages();
  }
  update() {
    let a = this.currentPage;
    (this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != a &&
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          })
        ),
      this.enableSliderLooping ||
        (this.isSlideVisible(this.sliderItemsToShow[0]) &&
        0 === this.slider.scrollLeft
          ? this.prevButton.setAttribute("disabled", "disabled")
          : this.prevButton.removeAttribute("disabled"),
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        )
          ? this.nextButton.setAttribute("disabled", "disabled")
          : this.nextButton.removeAttribute("disabled"));
  }
  isSlideVisible(a, b = 0) {
    let c = this.slider.clientWidth + this.slider.scrollLeft - b;
    return (
      a.offsetLeft + a.clientWidth <= c &&
      a.offsetLeft >= this.slider.scrollLeft
    );
  }
  onButtonClick(a) {
    a.preventDefault();
    let b = a.currentTarget.dataset.step || 1;
    (this.slideScrollPosition =
      "next" === a.currentTarget.name
        ? this.slider.scrollLeft + b * this.sliderItemOffset
        : this.slider.scrollLeft - b * this.sliderItemOffset),
      this.slider.scrollTo({ left: this.slideScrollPosition });
  }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    if (
      (super(),
      (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
      (this.enableSliderLooping = !0),
      !this.sliderControlWrapper)
    )
      return;
    (this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide")),
      this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
      (this.sliderControlLinksArray = Array.from(
        this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
      )),
      this.sliderControlLinksArray.forEach((a) =>
        a.addEventListener("click", this.linkToSlide.bind(this))
      ),
      this.slider.addEventListener(
        "scroll",
        this.setSlideVisibility.bind(this)
      ),
      this.setSlideVisibility(),
      "true" === this.slider.getAttribute("data-autoplay") &&
        this.setAutoPlay();
  }
  setAutoPlay() {
    (this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay")),
      (this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      ),
      this.addEventListener("mouseover", this.focusInHandling.bind(this)),
      this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
      this.addEventListener("focusin", this.focusInHandling.bind(this)),
      this.addEventListener("focusout", this.focusOutHandling.bind(this)),
      this.play(),
      (this.autoplayButtonIsSetToPlay = !0);
  }
  onButtonClick(a) {
    super.onButtonClick(a);
    let b = 1 === this.currentPage,
      c = this.currentPage === this.sliderItemsToShow.length;
    (b || c) &&
      (b && "previous" === a.currentTarget.name
        ? (this.slideScrollPosition =
            this.slider.scrollLeft +
            this.sliderFirstItemNode.clientWidth *
              this.sliderItemsToShow.length)
        : c &&
          "next" === a.currentTarget.name &&
          (this.slideScrollPosition = 0),
      this.slider.scrollTo({ left: this.slideScrollPosition }));
  }
  update() {
    super.update(),
      (this.sliderControlButtons = this.querySelectorAll(
        ".slider-counter__link"
      )),
      this.prevButton.removeAttribute("disabled"),
      this.sliderControlButtons.length &&
        (this.sliderControlButtons.forEach((a) => {
          a.classList.remove("slider-counter__link--active"),
            a.removeAttribute("aria-current");
        }),
        this.sliderControlButtons[this.currentPage - 1].classList.add(
          "slider-counter__link--active"
        ),
        this.sliderControlButtons[this.currentPage - 1].setAttribute(
          "aria-current",
          !0
        ));
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay);
  }
  focusOutHandling(a) {
    let b =
      a.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(a.target);
    this.autoplayButtonIsSetToPlay && !b && this.play();
  }
  focusInHandling(a) {
    let b =
      a.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(a.target);
    b && this.autoplayButtonIsSetToPlay
      ? this.play()
      : this.autoplayButtonIsSetToPlay && this.pause();
  }
  play() {
    this.slider.setAttribute("aria-live", "off"),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(
        this.autoRotateSlides.bind(this),
        this.autoplaySpeed
      ));
  }
  pause() {
    this.slider.setAttribute("aria-live", "polite"),
      clearInterval(this.autoplay);
  }
  togglePlayButtonState(a) {
    a
      ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.playSlideshow
        ))
      : (this.sliderAutoplayButton.classList.remove(
          "slideshow__autoplay--paused"
        ),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.pauseSlideshow
        ));
  }
  autoRotateSlides() {
    let a =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({ left: a });
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach((a, c) => {
      let b = a.querySelector("a");
      c === this.currentPage - 1
        ? (b && b.removeAttribute("tabindex"),
          a.setAttribute("aria-hidden", "false"),
          a.removeAttribute("tabindex"))
        : (b && b.setAttribute("tabindex", "-1"),
          a.setAttribute("aria-hidden", "true"),
          a.setAttribute("tabindex", "-1"));
    });
  }
  linkToSlide(a) {
    a.preventDefault();
    let b =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(a.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({ left: b });
  }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super(), this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(!0, "", !1),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.currentVariant
        ? (this.updateMedia(),
          this.updateURL(),
          this.updateVariantInput(),
          this.renderProductInfo(),
          this.updateShareUrl())
        : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (a) => a.value);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (a) => !a.options.map((a, b) => this.options[b] === a).includes(!1)
    );
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    let b = document.getElementById(`MediaGallery-${this.dataset.section}`);
    b.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      !0
    );
    let a = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!a) return;
    let c = a.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    a.prepend(c);
  }
  updateURL() {
    this.currentVariant &&
      "false" !== this.dataset.updateUrl &&
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateShareUrl() {
    let a = document.getElementById(`Share-${this.dataset.section}`);
    a &&
      a.updateUrl &&
      a.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateVariantInput() {
    let a = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    a.forEach((b) => {
      let a = b.querySelector('input[name="id"]');
      (a.value = this.currentVariant.id),
        a.dispatchEvent(new Event("change", { bubbles: !0 }));
    });
  }
  updatePickupAvailability() {
    let a = document.querySelector("pickup-availability");
    a &&
      (this.currentVariant && this.currentVariant.available
        ? a.fetchAvailability(this.currentVariant.id)
        : (a.removeAttribute("available"), (a.innerHTML = "")));
  }
  removeErrorMessage() {
    let a = this.closest("section");
    if (!a) return;
    let b = a.querySelector("product-form");
    b && b.handleErrorMessage();
  }
  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((a) => a.text())
      .then((d) => {
        let e = new DOMParser().parseFromString(d, "text/html"),
          a = document.getElementById(`price-${this.dataset.section}`),
          b = e.getElementById(
            `price-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          );
        b && a && (a.innerHTML = b.innerHTML);
        let c = document.getElementById(`price-${this.dataset.section}`);
        c && c.classList.remove("visibility-hidden"),
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
      });
  }
  toggleAddButton(e = !0, c, f = !0) {
    let a = document.getElementById(`product-form-${this.dataset.section}`);
    if (!a) return;
    let b = a.querySelector('[name="add"]'),
      d = a.querySelector('[name="add"] > span');
    if (
      b &&
      (e
        ? (b.setAttribute("disabled", "disabled"), c && (d.textContent = c))
        : (b.removeAttribute("disabled"),
          (d.textContent = window.variantStrings.addToCart)),
      !f)
    )
      return;
  }
  setUnavailable() {
    let a = document.getElementById(`product-form-${this.dataset.section}`),
      c = a.querySelector('[name="add"]'),
      d = a.querySelector('[name="add"] > span'),
      b = document.getElementById(`price-${this.dataset.section}`);
    c &&
      ((d.textContent = window.variantStrings.unavailable),
      b && b.classList.add("visibility-hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.variantData
    );
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  updateOptions() {
    let a = Array.from(this.querySelectorAll("fieldset"));
    this.options = a.map(
      (a) =>
        Array.from(a.querySelectorAll("input")).find((a) => a.checked).value
    );
  }
}
customElements.define("variant-radios", VariantRadios);

// Click-to-copy discount offer code handler
(function () {
  function copyTextToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      textArea.setAttribute("readonly", "");
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand("copy");
        document.body.removeChild(textArea);
        successful ? resolve() : reject(new Error("execCommand copy failed"));
      } catch (err) {
        document.body.removeChild(textArea);
        reject(err);
      }
    });
  }

  document.addEventListener("click", function (e) {
    const copyBtn = e.target.closest(".js-copy-code-btn, [data-copy-code]");
    if (!copyBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const code =
      copyBtn.getAttribute("data-copy-code") ||
      (copyBtn.querySelector(".offer-code-text")
        ? copyBtn.querySelector(".offer-code-text").textContent.trim()
        : copyBtn.textContent.trim());

    if (!code) return;

    copyTextToClipboard(code)
      .then(function () {
        if (typeof navigator.vibrate === "function") {
          try {
            navigator.vibrate(25);
          } catch (err) {}
        }

        copyBtn.classList.add("is-copied");
        copyBtn.setAttribute("aria-label", "Code " + code + " copied");

        clearTimeout(copyBtn._copyTimeout);
        copyBtn._copyTimeout = setTimeout(function () {
          copyBtn.classList.remove("is-copied");
          copyBtn.setAttribute("aria-label", "Copy discount code " + code);
        }, 2000);
      })
      .catch(function (err) {
        console.warn("Could not copy discount code:", err);
      });
  });
})();
//document.addEventListener('DOMContentLoaded', function () {
  // Create widget container
  //var widget = document.createElement('div');
 // widget.id = 'expert-widget';
 // widget.innerHTML = `
 //   //<button id="expert-toggle">Talk to an Expert</button>
 //   //<div id="expert-options">
 //     <a href="https://wa.me/919873113223" target="_blank" class="expert-option whatsapp">
 //       WhatsApp
//      </a>
 //     <a href="mailto:abc@yourdomain.com" class="expert-option email">
 //       Email
//      </a>
 //   </div>
 // `;
//
 // document.body.appendChild(widget);

  // Toggle logic
 // document.addEventListener('click', function (e) {
 //   var toggle = document.getElementById('expert-toggle');
 //   var options = document.getElementById('expert-options');
//
 //   if (!toggle || !options) return;
//
 //   if (e.target === toggle) {
 //     options.style.display = options.style.display === 'flex' ? 'none' : 'flex';
 //   } else if (!widget.contains(e.target)) {
//      options.style.display = 'none';
//    }
 // });
//});
